export const htmlToEntities = (html) => {
    return html.replace(/</g, '&lt;').replace(/>/g, '&gt;');
};

export const htmlRestoreEntities = (html) => {
    return html.replace(/&lt;/g, '<').replace(/&gt;/g, '>');
};
